import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@bufferapp/ui';

import { ChannelName, PostText } from '../styles';
import {
  ChannelWrapper,
  ChannelUsername,
  AttachmentWrapper,
  RetweetContent,
  RetweetHeader,
} from './style';

const RetweetItem = ({ retweet }) => {
  return (
    <AttachmentWrapper>
      <RetweetHeader>
        <Avatar
          src={retweet.avatar}
          fallbackUrl="https://s3.amazonaws.com/buffer-ui/Default+Avatar.png"
          alt={retweet.username}
          size="small"
          type="social"
          network="twitter"
        />
        <ChannelWrapper>
          <ChannelName type="p" color="grayDark">
            {retweet.accountName}
          </ChannelName>
          <ChannelUsername type="p" color="grayDark">
            @{retweet.username}
          </ChannelUsername>
        </ChannelWrapper>
      </RetweetHeader>
      <RetweetContent>
        <PostText type="p" color="grayDark">
          {retweet.text}
        </PostText>
      </RetweetContent>
    </AttachmentWrapper>
  );
};

RetweetItem.propTypes = {
  retweet: PropTypes.shape({
    avatar: PropTypes.string,
    accountName: PropTypes.string,
    username: PropTypes.string,
    text: PropTypes.string,
  }),
};

RetweetItem.defaultProps = {
  retweet: {},
};

export default RetweetItem;
